import { mergeMap } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { EMPTY, of } from 'rxjs';
import queryString from 'qs';
import Global from '../../store/global-selectors';

import * as Actions from './paging.actions';
import { FIRST_PAGE } from '../../services/pagination-service';

// Both these should be replaced with simple, idiomatic lookups via history and links or programmatic navigation events
export const writePagingInfoToUrl = (action$, { getState }, { push, history }) => {
  return action$.pipe(
    ofType(Actions.SET_VIEW_PAGE_AND_PAGE_SIZE),
    mergeMap(({ viewName }) => {
      const state = getState();
      const statePageData = Global.selectPagingViewPagingStats(state, {
        viewName,
      });
      if (!statePageData) {
        return EMPTY;
      }
      const pathname = history.location.pathname;
      const { page, pageSize } = statePageData;
      const search = queryString.stringify({ page, pageSize });

      push({ pathname, search });
      return EMPTY;
    }),
  );
};

export const readPagingInfoFromUrl = (action$, _, { history }) => {
  return action$.pipe(
    ofType(Actions.READ_PAGING_INFO_FROM_URL),
    mergeMap(({ viewName, defaultPageSize }) => {
      const search = history.location.search;
      const parsedQueryString = queryString.parse(search);
      const defaultObservable$ = of(Actions.setViewPageAndPageSize(viewName, FIRST_PAGE, defaultPageSize));
      if (!parsedQueryString) {
        return defaultObservable$;
      }
      const { page, pageSize } = parsedQueryString;
      if (page === undefined || pageSize === undefined) {
        return defaultObservable$;
      }
      const numberPage = Number.parseInt(page, 10);
      const numberPageSize = Number.parseInt(pageSize, 10);
      if (Number.isNaN(numberPage) || Number.isNaN(numberPageSize)) {
        return defaultObservable$;
      }
      return of(Actions.setViewPageAndPageSize(viewName, numberPage, numberPageSize));
    }),
  );
};
